import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CHANNEL_BACKGROUND_IMAGE, renderImage } from 'helpers/ImageHelper';
import { Link } from 'react-router';
import { helperGetChannelUrl, helperGetStaticContentUrl } from 'helpers/RouteHelper';
import {
  getSegmentModelMetadata,
  SegmentSources,
  handleAnalytics,
  Events,
} from '@foxcorp/delta-web-analytics';
import Style from '../ChannelList.module.scss';

const FALLBACK_IMAGE = 'FallBack-FOXNATION-min.jpg';
const fallbackChannel = helperGetStaticContentUrl('images', FALLBACK_IMAGE);

const ChannelItem = ({
  breakpoint,
  channel,
  collectionId,
  collectionLength,
  headline,
  horizontalPosition,
  isRecommended,
  playlistLength,
  verticalPosition,
}) => {
  const { description, id, images, name } = channel;
  const channelBackground = images?.still?.raw;
  const modelMetaData = channel?.trackingData?.properties?.modelMetaData;
  const channelImage = renderImage({
    alt: `${name} Channel`,
    breakpoint,
    className: Style.backgroundImage,
    dataTest: `${name} Channel Tile`,
    isHover: false,
    imageType: CHANNEL_BACKGROUND_IMAGE,
    src: channelBackground ?? fallbackChannel,
  });

  function handleClick() {
    handleAnalytics({
      event: Events.PLAYLIST_BUTTON_ACTION,
      payload: {
        page_action_location: SegmentSources.HOME,
        page_action_type: 'open page',
        page_collection_count: collectionLength,
        page_collection_id: collectionId,
        page_collection_title: headline,
        page_item_horizontal_position: horizontalPosition,
        page_item_vertical_position: verticalPosition,
        page_item_title: name,
        page_item_subtitle: description,
        page_playlist_length: playlistLength,
        page_recs_collection: isRecommended,
        page_recs_collection_model_id: modelMetaData?.modelId ?? ' ',
        page_recs_collection_request_id: modelMetaData?.requestId ?? ' ',
        page_recs_collection_result_set_id: modelMetaData?.resultSetId ?? ' ',
        page_recs_collection_source_id: modelMetaData?.sourceId ?? ' ',
        page_ui_element: 'tile',
        page_video_uid: 'no video uid',
        ...getSegmentModelMetadata(),
      },
    });
  }

  return (
    <Link
      to={helperGetChannelUrl(id)}
      className={classNames(Style.imageContainer, !channelBackground && Style.fallback)}
      onClick={handleClick}
      aria-label={name}
    >
      {channelImage}
    </Link>
  );
};

ChannelItem.propTypes = {
  breakpoint: PropTypes.string,
  channel: PropTypes.shape({}),
  collectionId: PropTypes.string,
  collectionLength: PropTypes.number,
  headline: PropTypes.string,
  horizontalPosition: PropTypes.number,
  isRecommended: PropTypes.bool,
  playlistLength: PropTypes.number,
  verticalPosition: PropTypes.number,
};

export default ChannelItem;
